import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

export default function UnlockBar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    if (!user || user === false || user.plan) return;
    (async () => {
      try {
        const { data } = await api.get("/profile");
        if (data.strength) setScore(data.strength.score || 0);
      } catch {}
    })();
  }, [user]);

  if (!user || user === false || user.plan) return null;

  const handleClick = () => { setTransitioning(true); setTimeout(() => navigate("/paywall"), 700); };

  return (
    <>
      <div data-testid="unlock-bar">
        <div className="bg-[#181207] border-b border-[#D4AF37]/25">
          <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 min-w-0">
              <Lock size={12} className="text-[#D4AF37] flex-shrink-0" />
              <span className="text-[11px] text-[#E5E5E5] font-semibold whitespace-nowrap">Not on directory · Profile not shareable</span>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              {score > 0 && (
                <span className="text-[9px] text-[#D4AF37]/80 font-bold tabular-nums hidden md:inline" data-testid="unlock-progress">{score}% complete</span>
              )}
              <button onClick={handleClick} className="bg-[#D4AF37] text-[#0A0A0A] font-bold uppercase tracking-wider text-[9px] px-4 py-1.5 rounded-sm hover:bg-[#C5A059] transition-colors flex items-center gap-1" data-testid="unlock-bar-btn">
                PUBLISH — $19 <ArrowRight size={10} />
              </button>
            </div>
          </div>
        </div>
        <div className="bg-[#0A0A0A] border-b border-[#1a1a1a] py-1.5">
          <p className="text-center text-[9px] text-[#555] tracking-wide" data-testid="unlock-bar-footnote">
            Publishing makes you visible to scouts and unlocks your shareable link
          </p>
        </div>
      </div>
      {transitioning && (
        <div className="fixed inset-0 z-50 bg-[#0A0A0A]/90 flex items-center justify-center" data-testid="unlock-transition">
          <div className="text-center animate-fade-in">
            <Lock size={20} className="text-[#D4AF37] mx-auto mb-2" />
            <p className="text-sm text-[#F5F5F5]">You're one step away from publishing your profile</p>
          </div>
        </div>
      )}
    </>
  );
}
